<template>
    <div class="app-maintenance">
        <div class="maintenance-container">
            <div class="maintenance-header">
                <img src="@/assets/img/card_logo.png" alt="NOVA-CASINO Logo" class="logo" />
            </div>
            
            <div class="maintenance-content">
                <div class="status-indicator">
                    <div class="status-dot"></div>
                    <span class="status-text">System Maintenance</span>
                </div>
                
                <h1 class="maintenance-title">We're Currently Performing Scheduled Maintenance</h1>
                
                <p class="maintenance-description">
                    Our platform is temporarily unavailable while we perform essential system updates and improvements. 
                    We apologize for any inconvenience this may cause.
                </p>
                
                <div class="maintenance-details">
                    <div class="detail-item">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm1-13H9v6h5V9h-4V5z" fill="currentColor"/>
                        </svg>
                        <span>Expected Duration: 2-4 hours</span>
                    </div>
                    <div class="detail-item">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm4.707-8.707l-4-4a1 1 0 00-1.414 0l-4 4a1 1 0 001.414 1.414L9 8.414V13a1 1 0 002 0V8.414l2.293 2.293a1 1 0 001.414-1.414z" fill="currentColor"/>
                        </svg>
                        <span>All services will resume shortly</span>
                    </div>
                </div>
                
                <div class="maintenance-footer">
                    <p class="footer-text">Thank you for your patience and understanding.</p>
                    <p class="footer-subtext">For urgent inquiries, please contact our support team.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AppMaintenance'
    }
</script>

<style scoped>
    .app-maintenance {
        width: 100%;
        min-height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 40px 20px;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        background: linear-gradient(135deg, rgba(19, 22, 41, 0.95) 0%, rgba(13, 19, 24, 0.98) 100%);
    }

    .maintenance-container {
        max-width: 800px;
        width: 100%;
        background: rgba(26, 26, 26, 0.6);
        backdrop-filter: blur(10px);
        border-radius: 16px;
        padding: 60px 50px;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
        border: 1px solid rgba(255, 255, 255, 0.1);
    }

    .maintenance-header {
        display: flex;
        justify-content: center;
        margin-bottom: 50px;
    }

    .maintenance-header .logo {
        width: 180px;
        height: auto;
        object-fit: contain;
    }

    .maintenance-content {
        text-align: center;
    }

    .status-indicator {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        padding: 8px 20px;
        background: rgba(85, 158, 228, 0.15);
        border: 1px solid rgba(85, 158, 228, 0.3);
        border-radius: 50px;
        margin-bottom: 30px;
    }

    .status-dot {
        width: 10px;
        height: 10px;
        background: #559ee4;
        border-radius: 50%;
        animation: pulse 2s ease-in-out infinite;
    }

    @keyframes pulse {
        0%, 100% {
            opacity: 1;
            transform: scale(1);
        }
        50% {
            opacity: 0.6;
            transform: scale(1.2);
        }
    }

    .status-text {
        font-size: 14px;
        font-weight: 500;
        color: #559ee4;
        letter-spacing: 0.5px;
        text-transform: uppercase;
    }

    .maintenance-title {
        font-size: 36px;
        font-weight: 600;
        color: #ffffff;
        margin-bottom: 24px;
        line-height: 1.3;
        letter-spacing: -0.5px;
    }

    .maintenance-description {
        font-size: 16px;
        line-height: 1.7;
        color: #bbbfd0;
        margin-bottom: 40px;
        max-width: 600px;
        margin-left: auto;
        margin-right: auto;
    }

    .maintenance-details {
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin-bottom: 40px;
        padding: 30px;
        background: rgba(19, 22, 41, 0.4);
        border-radius: 12px;
        border: 1px solid rgba(255, 255, 255, 0.05);
    }

    .detail-item {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        color: #bbbfd0;
        font-size: 15px;
    }

    .detail-item svg {
        color: #559ee4;
        flex-shrink: 0;
    }

    .maintenance-footer {
        padding-top: 30px;
        border-top: 1px solid rgba(255, 255, 255, 0.1);
    }

    .footer-text {
        font-size: 15px;
        color: #ffffff;
        font-weight: 500;
        margin-bottom: 8px;
    }

    .footer-subtext {
        font-size: 14px;
        color: #8b8fa3;
    }

    @media only screen and (max-width: 768px) {
        .maintenance-container {
            padding: 40px 30px;
        }

        .maintenance-header .logo {
            width: 150px;
        }

        .maintenance-title {
            font-size: 28px;
        }

        .maintenance-description {
            font-size: 15px;
        }

        .maintenance-details {
            padding: 24px 20px;
        }

        .detail-item {
            font-size: 14px;
        }
    }

    @media only screen and (max-width: 480px) {
        .app-maintenance {
            padding: 20px 15px;
        }

        .maintenance-container {
            padding: 30px 20px;
        }

        .maintenance-header .logo {
            width: 120px;
        }

        .maintenance-title {
            font-size: 24px;
            margin-bottom: 20px;
        }

        .maintenance-description {
            font-size: 14px;
            margin-bottom: 30px;
        }

        .maintenance-details {
            padding: 20px 16px;
            gap: 12px;
        }

        .detail-item {
            font-size: 13px;
        }

        .status-indicator {
            padding: 6px 16px;
            font-size: 12px;
        }

        .footer-text {
            font-size: 14px;
        }

        .footer-subtext {
            font-size: 13px;
        }
    }
</style>
